export class SetProjectRoleAction {
  public static readonly type = '[Authorisation] SetProjectRoleAction';
  constructor(
    public readonly userId: string,
    public readonly projectId: string,
    public readonly template: boolean,
  ) {}
}
